import { render, staticRenderFns } from "./registor.vue?vue&type=template&id=f6e82a9a"
import script from "./registor.vue?vue&type=script&lang=js"
export * from "./registor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports